"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseTab = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = require("../../Theme");

var _Clickable = require("../Clickable");

var _Text = require("../Text");

var _v = require("./tokens/v2");

var _v2 = require("./tokens/v3");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/**
 * Extends `Text`. Should always be nested within a `BaseTabs` container.
 *
 * Use the `as` prop to alter behavior.
 * E.g.: `<BaseTab as={RouterLink} to="/foo">Foo</BaseTab>`
 * or `<BaseTab as={Clickable} onClick={handleClick}>Foo</BaseTab>`
 */


var BaseTab = (0, _styledComponents.default)(_Text.Text).withConfig({
  displayName: "BaseTab",
  componentId: "sc-1qn17bx-0"
})(["display:flex;width:100%;position:relative;text-decoration:none;white-space:nowrap;z-index:1;", ""], function (props) {
  var states = (0, _Theme.getThemeConfig)(props, {
    v2: _v.STATES,
    v3: _v2.STATES
  });
  return (0, _styledComponents.css)(["", " ", " ", " ", " &:hover:not(:disabled){", "}&:focus{outline:0;", "}"], states.default, props.hover && states.hover, props.focus && states.focus, props.active && states.active, states.hover, states.focus);
});
exports.BaseTab = BaseTab;
BaseTab.defaultProps = {
  variant: "mediumText",
  mb: "-1px",
  alignItems: "flex-start",
  justifyContent: "center",
  textAlign: "center"
};
BaseTab.displayName = "BaseTab";
/**
 * So this is interesting: We can trick styled-components into correcting the CSS specificity (Text > Clickable)
 * by simply including a Clickable here.
 */
// @ts-expect-error  MIGRATE_STRICT_MODE
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var __Ignore__ = _Clickable.Clickable;